export const validateEmptyValue = (value) => {
  if (value) {
    return value?.toString();
  }
  if (!value) {
    return '';
  }
};
